<aside class="main-sidebar sidebar-light-primary">
	<!-- Logo -->
	<a href="#"  [ngClass]="isBrandLink ? 'brand-link text-center' : 'brand-link1 text-center'">
	  <img src="assets/dist/img/AdminLTELogo1.png" alt="Logo" class="brand-image" style="max-height: 50px;">
	</a>
  
	<!-- Sidebar -->
	<div class="sidebar">
	  	<!-- Sidebar Menu -->
	  	<nav class="mt-2">
			<ul class="nav nav-pills nav-sidebar flex-column" role="menu">
		  		<!-- Expandable Menu -->
		  		<li class="nav-item has-treeview" (click)="menu_open(x)"  [ngClass]="x.active?'menu-open':''"  *ngFor="let x of list" style="cursor: pointer;">
					<a  class="nav-link" (click)="x.active=!x.active">
						<img class="icon" src="assets/dist/img/cooperate.svg" alt="link Icon" style="width: 24px;height: 24px;margin-right: 5%;">
			  			<p *ngIf="x.type*1===0 && isBrandLink">
							{{ x.item }}
							<i class="right fas fa-angle-left"></i>
			  			</p>
					</a>
					<ul [ngClass]="isBrandLink ? 'nav nav-treeview' : 'nav nav-treeview-mob'" *ngIf="x.type*1===0">
					  	<li class="nav-item" *ngFor="let y of x.subitem" style="cursor: pointer;">
							<div style="display: flex;align-items: center;justify-content: center;">
								<img *ngIf="y.type*1 == 4" class="icon" src="assets/dist/img/Rectangle.png" alt="link Icon" style="width: 6px;height: 18px;">
								<a
									*ngIf="y.type*1 == 4"
									[ngClass]="now==y.id?'active':''" 
						 			(click)="now = y.id;menu_hit(y.id);"
						  			class="nav-link" routerLink="{{y.url}}"
									style="	padding-left: 3px;" >
						   			<p>{{ y.item }}</p>
					 			</a>
							</div>
					  	</li>
					</ul>
		  		</li>
			</ul>
	  	</nav>
	</div>
	<!-- /.sidebar -->
	<div class="circle-container" data-widget="pushmenu" (click)="toggleLinkClass($event)">
		<button [ngClass]="isRotated ? 'main-buttons' : 'main-button'">
			<i class="material-icons">arrow_back</i> <!-- 可替換為具體的 icon -->
		</button>
	</div>
</aside>
